export default [
  {
    path: '/postal/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: 'setting',
        name: 'postalSetting',
        component: () => import('@/views/Postal/Setting.vue'),
        meta: {
          prev: 'mainPage/postal'
        }
      }
    ]
  }
]
